var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.options,"label":"Select"},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('ns-icon',{attrs:{"icon-name":"icon-chevron-down","height":"20","width":"20"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }